<template>
  <fragment>
    <v-col cols="12" sm="6" :class="{ agent: value.agentType !== undefined }">
      <v-select
        :items="agentTypes"
        item-text="name"
        item-value="id"
        v-model="value.agentType"
        label="Признак агента"
        placeholder="нет"
        :disabled="disabled"
        clearable
      />
    </v-col>
    <v-col cols="12" v-if="value.agentType !== undefined" class="agent">
      <v-container class="pa-0" fluid>
        <v-row dense>
          <v-col v-if="[0, 1, 2, 3].includes(value.agentType)" cols="12">
            <phone-number-field
              label="Телефон платёжного агента"
              multiple
              v-model="value.agentPhones"
              :rules="rules[rulesPrefix + 'agentPhones']"
              :disabled="disabled"
              clearable
            />
          </v-col>
          <template v-if="[0, 1].includes(value.agentType)">
            <v-col cols="12">
              <v-text-field
                label="Название операции"
                v-model="value.agentOperation"
                :rules="rules[rulesPrefix + 'agentOperation']"
                :disabled="disabled"
                clearable
              />
            </v-col>
            <v-col cols="7" sm="8">
              <v-text-field
                label="Оператор перевода"
                v-model="value.transferOperatorName"
                :rules="rules[rulesPrefix + 'transferOperatorName']"
                :disabled="disabled"
                clearable
              />
            </v-col>
            <v-col cols="5" sm="4">
              <v-text-field
                label="ИНН оператора перевода"
                v-model="value.transferOperatorINN"
                :rules="rules[rulesPrefix + 'transferOperatorINN']"
                :disabled="disabled"
                clearable
              />
            </v-col>
            <v-col cols="7" sm="8">
              <v-text-field
                label="Адрес оператора перевода"
                v-model="value.transferOperatorAddress"
                :rules="rules[rulesPrefix + 'transferOperatorAddress']"
                :disabled="disabled"
                clearable
              />
            </v-col>
            <v-col cols="5" sm="4">
              <phone-number-field
                label="Телефон оператора перевода"
                multiple
                v-model="value.transferOperatorPhones"
                :rules="rules[rulesPrefix + 'transferOperatorPhones']"
                :disabled="disabled"
                clearable
              />
            </v-col>
          </template>
          <v-col v-if="[2, 3].includes(value.agentType)" cols="12">
            <phone-number-field
              label="Телефон оператора по приему платежей"
              multiple
              v-model="value.paymentOperatorPhones"
              :rules="rules[rulesPrefix + 'paymentOperatorPhones']"
              :disabled="disabled"
              clearable
            />
          </v-col>
          <v-col cols="7" sm="8">
            <phone-number-field
              label="Телефон поставщика"
              multiple
              v-model="value.supplierPhones"
              :rules="rules[rulesPrefix + 'supplierPhones']"
              :disabled="disabled"
              clearable
            />
          </v-col>
          <v-col cols="5" sm="4">
            <v-text-field
              label="ИНН поставщика"
              v-model="value.supplierINN"
              :rules="rules[rulesPrefix + 'supplierINN']"
              :disabled="disabled"
              clearable
            />
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </fragment>
</template>

<script>
import { AgentTypes } from "@/datastore/enums";
import { Fragment } from "vue-fragment";

export default {
  name: "AgentFields",
  components: { Fragment },
  props: {
    value: Object,
    disabled: Boolean,
    rules: {
      type: Object,
      default: () => ({})
    },
    rulesPrefix: String
  },
  data() {
    return {
      agentTypes: AgentTypes
    };
  }
};
</script>

<style scoped>
.agent {
  background-color: #f8f8ff;
}
</style>
